import styled from "styled-components"

import {greys} from "@irati/ui/src/global/colors"
import {IconTooltip} from "@irati/ui/src/Tooltip"
import {Para} from "@irati/ui/src/Labels"

interface ContainerProps{
  width?: number
}

export const ImageWrapper = styled.span`
  background: ${greys.lightest};
  border-radius: 50%;
  margin-right: 20px;
`

export const Container = styled.div<ContainerProps>`
  width: ${({width}) => width}%;
`

export const ExpandedPara = styled(Para)`
  white-space: normal;
  margin-bottom: 0;
`

export const StyledTooltip = styled(IconTooltip)`
  margin-left: 5px;
  vertical-align: text-bottom;
`

export const NowrapSpan = styled.span`
  white-space: nowrap;
`

export const PaddingSpan = styled.span`
  padding-left: 5px;
`
